import React, { useState } from 'react'
import { Modal, Button } from "react-bootstrap"
import { useNavigate } from 'react-router-dom';
import OtpInput from "react-otp-input";
import "./ModalPassword.scss"
import Laptop2 from "../../../assets/img/laptop2.png"

const ModalPassword = ({ show, onClose, objData, email, activated, sendCode, onSuccess, onError }) => {

    const navigate = useNavigate()

    const [otp, setOtp] = useState("");
    const [askForRecovery, setAskForRecovery] = useState(false);
    const [inputRecoveryCode, setInputRecoveryCode] = useState("");

    const [error, setError] = useState(null)
    const [otpPass, setOtpPass] = useState("")

    const verificar = async (payload) => {
        try {
            const endpoint = activated
                ? `${process.env.REACT_APP_API_URL}/apis/user/2FA/validate`
                : `${process.env.REACT_APP_API_URL}/apis/user/2FA/activate`;

            const res = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ...payload })
            });

            const data = await res.json();

            if (data.state === "OK") {
                onSuccess();
            } else {
                onError(data.errorDetalle);
            }

        } catch (err) {
            onError("Error de conexión. Intenta nuevamente.");
        }
    };

    const handleOtpChange = (value) => {
        setOtp(value);
        if (value.length === 6) {
            verificar({ code: value, idUser: objData?.id });
        }
    };

    const handleRecoveryVerify = () => {
        if (!inputRecoveryCode.trim()) {
            return;
        }
        verificar({ recoveryCode: inputRecoveryCode, idUser: objData?.id });
    };

    const renderOtpInput = (inputProps) => (
        <input
            {...inputProps}
            style={{
                width: "3rem",
                height: "3rem",
                margin: "0 0.25rem",
                fontSize: "1.8rem",
                borderRadius: 4,
                border: "1px solid #ccc",
                textAlign: "center"
            }}
        />
    );

    const verifyMail = email || "";
    const atIndex = email.indexOf("@");
    const maskedEmail =
        atIndex > 3
        ? verifyMail.slice(0, 3) + "*".repeat(atIndex - 3) + email.slice(atIndex)
        : verifyMail;


    // validar 6 dígitos cuando no tiene 2FA
    const validate = (data) => {
        const errors = {}
        if(!data.trim()){
            errors.codigo = "Ingrese los 6 dígitos enviados al correo."
        }
        return errors;
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validate(otpPass)
        if(Object.keys(newErrors).length === 0){
            setError(null)
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/recupera/validarCodigo`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        mailUser: email,
                        codigo: otpPass
                    })
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0) {
                    // error 99 de que no existe el mail
                    setError(data.errorDetalle || data.codeError)
                } else if (errorCode === 25) {
                    // errores respecto al código
                    setError(data.errorDetalle || data.codeError)
                } else {
                    // ok
                    navigate("/change-password", { state: { email } })
                }
            } catch (error) {
                setError("Error en el backend. Intenta nuevamente.")
            }
        } else {
            setError(newErrors.codigo)
        }
    }

    return (
        <Modal 
            show={show} 
            onHide={onClose} 
            centered 
            dialogClassName='modal-auto-width'
            size='md'
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3 className='text-blue-500 fw-medium'>
                        {activated && !askForRecovery && "Verificar segundo factor de autenticación"}
                        {activated && askForRecovery && "Recuperar acceso"}
                        {/* {sendCode && "Envío de mail con código de 6 dígitos"} */}
                    </h3>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* 2FA activado */}
                {activated && !askForRecovery && (
                    <>
                        <h5>Ingrese el código de 6 dígitos de la app:</h5>
                        <div className="d-flex justify-content-center mt-4">
                            <OtpInput
                                value={otp}
                                onChange={handleOtpChange}
                                numInputs={6}
                                isInputNum
                                renderInput={renderOtpInput}
                            />
                        </div>
                        <p className="mt-3">Si perdiste acceso a tu dispositivo hacé click{" "}
                            <span
                                style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
                                onClick={() => setAskForRecovery(true)}
                            >
                                aquí
                            </span>.
                        </p>
                    </>
                )}
                {/* Recuperación */}
                {activated && askForRecovery && (
                    <>
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Ingresa tu código de recuperación"
                                value={inputRecoveryCode}
                                onChange={(e) => setInputRecoveryCode(e.target.value)}
                            />
                            <Button onClick={handleRecoveryVerify} disabled={!inputRecoveryCode.trim()}>Verificar</Button>
                        </div>
                        <p>Si no tienes acceso al código de recuperación, contacta a un administrador.</p>
                        <p>
                            Para volver a la pantalla anterior haz click{" "}
                            <span
                                style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
                                onClick={() => setAskForRecovery(false)}
                            >
                                aquí
                            </span>.
                        </p>
                    </>
                )}
                {/* Código de 6 dígitos si no tiene el 2FA activado */}
                {sendCode && (
                    <>
                        <div className='sendCode d-flex flex-column align-items-center'>
                            <img className='mb-4' src={Laptop2} alt='Usuario'/>
                            <h3 className='text-blue-500 fw-medium text-center mb-2'>¡Te enviamos un correo!</h3>
                            <p className='m-0 mb-4 text-center'>Te enviamos un código de 6 dígitos a tu correo: <span className='fw-medium text-blue-500'>{maskedEmail}</span></p>
                            <p className='small-text m-0 mb-2 fw-medium text-blue-500'>Ingresa los 6 dígitos</p>
                            <form className='d-flex flex-column align-items-center' onSubmit={handleSubmit}>
                                <div className="d-flex flex-column align-items-center">
                                    <OtpInput
                                        value={otpPass}
                                        onChange={setOtpPass}
                                        numInputs={6}
                                        isInputNum
                                        renderInput={renderOtpInput}
                                    />
                                </div>
                                {error !== null && <div className='mt-2 form__error'><i className="bi bi-exclamation-circle pe-2 text-danger"></i><span className='text-danger'>{error}</span></div>}
                                <button type='submit' className='mt-4 btn btn-primary rounded-pill fw-medium px-4'>Enviar código</button>
                            </form>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default ModalPassword